'use strict';

const _ = require('lodash');

function ShareService ($http, $rootScope, clipboard, AnalyticsService, AppDialogsActions, sbAuth, Flux, IdentityService, SaturnGrowl, MetricsService) {
  //************ PRIVATE VARIABLES ************\\
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const SiteStore = Flux.Store.get('SiteStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');

  const sendAnalytics = (dc, site, action, mixin) => {
    let params = {
      dataCaptureId: dc.id,
      siteId: site.id,
      siteName: site.name
    };

    if (mixin) {
      params = Object.assign(params, mixin);
    }

    AnalyticsService.track('[CORE] Sharing', action, params);
  };

  //************ PUBLIC VARIABLES ************\\
  this.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  this.clipboardSupported = clipboard.supported;
  this.copiedButton = null;
  this.shareUrl = null;

  //************ PUBLIC METHODS ************\\

  this.onCopyShareUrl = () => {
    const currentDataCapture = DataCaptureStore.get('current');
    const currentSite = SiteStore.get('current');

    sendAnalytics(currentDataCapture, currentSite, 'Copy URL');

    clipboard.copyText(this.shareUrl);
    this.copiedButton = 'url';
  };

  this.onCopyShareEmbed = () => {
    const currentDataCapture = DataCaptureStore.get('current');
    const currentSite = SiteStore.get('current');

    sendAnalytics(currentDataCapture, currentSite, 'Copy Embed');

    clipboard.copyText(this.getShareIframeCode());
    this.copiedButton = 'embed';
  };

  this.getShareIframeCode = () => `<iframe src="${this.shareUrl}" width="100%" height="640px" frameborder="0"></iframe>`;


  this.handleShareClick = () => {

      MetricsService.track('shareSite', 'shareSiteRequest', {
        forceNewFlow: true
      });
      const currentDataCapture = DataCaptureStore.get('current');
      const currentSite = SiteStore.get('current');
      const currentLayerType = TopControlsStore.get('currentLayerType');
      const currentDataCaptureId = currentDataCapture.id;

      // used to verify if we need a new share url
      if (this.sharedDataCaptureId === currentDataCaptureId && this.sharedLayerType === currentLayerType) {
        return;
      }

      this.sharedDataCaptureId = currentDataCaptureId;
      this.sharedLayerType = currentLayerType;
      this.copiedButton = null;
      this.shareUrl = null;

      sendAnalytics(currentDataCapture, currentSite, 'Share Click', {layerType: currentLayerType});

      sbAuth.getToken().then((token) => {
        $http({
          method: 'POST',
          data: {
            dataCapture: currentDataCaptureId,
            site: currentSite.id,
            layerType: currentLayerType
          },
          headers: {
            'Authorization': `Bearer ${token}`
          },
          url: `${IdentityService.getApiUri()}shares`
        })
        .then((res) => {
          const url = _.get(res, ['data', 'data', 'shortUrl']);

          MetricsService.track('shareSite', 'shareSiteReady');
          if (!url) {
            throw new Error('No url has been found');
          }

          this.shareUrl = url;
        })
        .catch(() => {
          this.shareUrl = null;
          this.copiedButton = null;

          SaturnGrowl.newGrowl('An error has occurred sharing your map. Please contact your project admin.', {
            type: 'warning',
            time: -1,
            id:'share-error'
          });
        });
      });
    };
}

ShareService.$inject = ['$http', '$rootScope', 'clipboard', 'AnalyticsService', 'AppDialogsActions', 'sbAuth', 'sbFlux', 'IdentityService', 'SaturnGrowl', 'MetricsService'];

module.exports = ShareService;



// WEBPACK FOOTER //
// ./src/app/dash/ShareService.js